export default "/_next/static/data/hero-good-data.json-8c7f416ad4f91df3d68b72cb5637a167.json";